import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import { gridSpacing } from 'store/constant';
import LoaderCustom from 'ui-component/LoaderCustom';
import { SET_SIDE_MENU } from 'store/actions';
import { CLEAR_CAMPAIGN_LIST } from '../redux/advertiser/advertiserTypes';
import { fetchGTVCampaignsForAdvertiser } from '../redux/advertiser/advertiserActions';
import SearchBarGTV from 'components/Dashboard/SearchBarGTV';
import GTVSection from 'components/gtv/GTVReportView';

const SECTIONS = [
  { key: 'overall', title: 'Overall Advertiser Performance', dimensionField: 'advertiser_name', dimensionHeader: 'Advertiser' },
  { key: 'creative', title: 'Creative Level Performance', dimensionField: 'creative_name', dimensionHeader: 'Creative Name' }
];

const GTVPage = ({ advertiserList, gtvState, startDate, endDate }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    localStorage.setItem('showSideMenu', true);
    dispatch({ type: SET_SIDE_MENU, showSideMenu: true });

    dispatch({ type: CLEAR_CAMPAIGN_LIST });
    const advertiserGuid = localStorage.getItem('advertiserId');
    const sfId = localStorage.getItem('sfId') || '';
    if (advertiserGuid && startDate && endDate) {
      dispatch(fetchGTVCampaignsForAdvertiser(advertiserGuid, sfId, startDate, endDate));
    }
  }, [dispatch, startDate, endDate]);

  if (advertiserList.length === 0) {
    return <LoaderCustom />;
  }

  return (
    <>
      <Paper elevation={1} spacing={gridSpacing} className="stickyBox">
        <SearchBarGTV />
      </Paper>
      <Grid container spacing={gridSpacing} sx={{ mt: 0 }}>
        {SECTIONS.map((sec) => (
          <Grid item xs={12} key={sec.key}>
            <GTVSection
              title={sec.title}
              dimensionField={sec.dimensionField}
              dimensionHeader={sec.dimensionHeader}
              loading={gtvState.loading}
              rows={gtvState[sec.key]}
              error={gtvState.error}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

const mapStateToProps = (state) => ({
  advertiserList: state.advertiserReducer.advertiser_list,
  gtvState: state.gtvReducer,
  startDate: state.campaignReducer.start_date,
  endDate: state.campaignReducer.end_date
});

export default connect(mapStateToProps)(GTVPage);
